var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',[(!_vm.$slots.default)?[(_vm.content)?_c('span',{class:_vm.textClass},[_vm._v(_vm._s(_vm.content)+_vm._s(_vm.sufixo))]):_c('span',{staticClass:"text--disabled",class:_vm.textClass},[_vm._v("N/A")])]:_vm._e(),_vm._t("default")],2)}
var staticRenderFns = []

export { render, staticRenderFns }